<template>
<div class="container">
    <div class="alert alert-warning">
        {{$t("Vous désirez effacer votre compte ? Laissez-vous guider.")}}
    </div>
    <div class="row" v-if="step=='step1'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t("Connaissez vous votre identifiant ?")}}</h5>
                    <div class="form-label-group">
                        <input type="text" id="username" name="username" v-model="username" class="form-control" v-bind:placeholder="$t('Utilisateur Geoportail')" required="" autofocus=""  autocomplete="username">
                        <label for="username">{{$t("Utilisateur Geoportail")}}</label>
                    </div>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="deleteaccount">{{$t("Effacer mon compte")}}</button>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="step2">{{$t("Je ne connais pas mon identifiant")}}</button>
                    <p class="forgot-password text-right mt-2 mb-4">
                        <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
                    </p>
            </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='step2'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t("Connaissez vous votre adresse email ?")}}</h5>
                    <div class="form-label-group">
                        <input type="text" id="email" name="email" v-model="email" class="form-control" v-bind:placeholder="$t('Adresse email')" required="" autofocus=""  autocomplete="email">
                        <label for="username">{{$t("Adresse email")}}</label>
                    </div>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="deleteaccount">{{$t("Effacer mon compte")}}</button>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="step3">{{$t("Je ne connais pas mon adresse email")}}</button>
                    <p class="forgot-password text-right mt-2 mb-4">
                        <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link> |
                    </p>
            </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='step3'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t("Si vous ne connaissez ni votre adresse email utilisée lors de votre inscription ni votre identifiant, veuillez contacter notre support, soit par mail : support@geoportail.lu soit par téléphone pendant les heures de bureau : (+352) 24754 - 401")}}</h5>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="step1">{{$t("Etape précédente")}}</button>
                    <p class="forgot-password text-right mt-2 mb-4">
                        <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link>
                    </p>
            </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='success'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t("Un email avec les instructions vous a été envoyé")}}</h5>
                    <p class="forgot-password text-right mt-2 mb-4">
                        <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link>
                    </p>
            </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="step=='error'">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
            <div class="card-body">
                <h5 class="card-title text-center">{{$t("Une erreur est survenue. veuillez contacter notre support, soit par mail : support@geoportail.lu soit par téléphone pendant les heures de bureau : (+352) 24754 - 401")}}</h5>
                    <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="step1">{{$t("Recommencer")}}</button>
                    <p class="forgot-password text-right mt-2 mb-4">
                        <router-link to="/">{{$t("Retour à l'écran de connexion")}}</router-link>
                    </p>
            </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { ref } from 'vue';
import i18n from "@/i18n"
export default {
    setup() {
        const username = ref("")
        const email = ref("")
        const step = ref("step1")
        const step2 = function () {
            step.value = "step2";
        }
        const step1 = function () {
            step.value = "step1";
        }
        const step3 = function () {
            step.value = "step3";
        }
        const deleteaccount = function() {
            let formData = new FormData();
            formData.append('lang', i18n.global.locale.value);
            switch(step.value) {
                case 'step1':
                    formData.append('username', username.value);
                    break;
                case 'step2':
                    formData.append('email', email.value);
                    break;
            }
            fetch("api/deleteaccount", {
                body: formData,
                method: "post"
            }).then(function(resp) {
                resp.json().then(function(status) {
                    if ('success' in status && status.success == true) {
                         step.value = "success";
                    } else {
                        step.value = "error";
                    }
                });
            });
            
        }
        // expose to template
        return {
            username,
            email,
            step,
            step1,
            step2,
            step3,
            deleteaccount,
        }
    }
}
</script>

<style>

</style>